import {Component, Input, OnInit} from '@angular/core';
import {Order} from '../../../../../Models/Order';
import {Router} from '@angular/router';
import {ServiceRequest} from '../../../../../Models/ServiceRequest';
import {ServiceRequestService} from '../../../../../Services/service-request.service';

@Component({
  selector: 'app-reply-step-reorder',
  templateUrl: './reply-step-reorder.component.html',
  styleUrls: ['./reply-step-reorder.component.scss']
})
export class ReplyStepReorderComponent implements OnInit {

  @Input() Index;
  @Input() isActive;
  public order: Order = new Order();
  public serviceRequest: ServiceRequest = new ServiceRequest();
  public replyItem;

  constructor(
    private requestService: ServiceRequestService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.requestService.serviceRequest.subscribe(serviceRequest => {
      if (serviceRequest.reply) {
        this.serviceRequest = serviceRequest;
        this.serviceRequest.reply.replyItems = this.serviceRequest.reply.replyItems.filter(item => !item.solutionStep.restricted);
        this.replyItem = this.serviceRequest.reply.replyItems[this.Index];
        if (this.replyItem.replyReOrder && this.replyItem.replyReOrder.relatedOrder) {
          this.order = this.replyItem.replyReOrder.relatedOrder;
        }
      }
    });
  }

  goToOrder() {
    this.router.navigateByUrl('back-office/order/' + this.order.id + '/edit');
  }

  redirectToEditOrder() {
    this.router.navigateByUrl('back-office/service/request/'
      + this.serviceRequest.id +
      '/reply/' + this.replyItem.id +
      '/order/' + this.serviceRequest.order.id
    );
  }
}
